export default {
    getQuestionResponseList: (state) => (questionnaire) => {
        const questionnaireResponse = state.questionnaire[questionnaire]
        if(questionnaireResponse) {
            return questionnaireResponse.questionList
        }
        return []
    }
}
